<template>
  <div id="parent-component" class="collection-details-page">
    <PageHeader
        v-if="!collection_loading && Object.keys(item).length"
        :title="item.name || ''"
        class="collection-details-page-header"
        icon="uil-notebooks"
    />

    <AppModal :visible.sync="showAddContentModalVisible" :title="$t('collectionDetail.add_content')" width="75%" max-height="86vh" :bottom-sheet="true">
      <CollectionContentModal ref="addContentModal" :collection-id="collectionId" @onSubmit="addContentModalSubmit"/>
    </AppModal>

    <AppModal :visible.sync="showEditContentModalVisible" :title="$t('collectionDetail.edit_content')" width="75%" max-height="86vh" :bottom-sheet="true">
      <CollectionContentModal
          ref="editContentModal"
          mode="edit"
          :collection-id="collectionId"
          :content="selectedExternalContent"
          @onSubmit="editContentModalSubmit"
      />
    </AppModal>

    <AppModal :title="$t('collectionDetail.person_add_remove')" :visible.sync="showShareUserModal" max-height="90vh"
              width="600px" :bottom-sheet="true">
      <CollectionShareModal :history-only="shareHistoryMode" :sharedIds.sync="sharedIds" :users="shareUsers"/>
    </AppModal>

    <!-- SKELETON LOADING -->
    <CollectionDetailSkeleton v-if="collection_loading" />

    <div v-show="!collection_loading && Object.keys(item).length === 0"
         class="course-details-wrapper topic-1 uk-light pt-5">
      <div class="container p-sm-0">
        <div uk-grid>
          <div class="course-details">
            <h1 class="text-primary">
              {{ $t('collectionDetail.access_denied') }}
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile: CollectionCardTrailer en üstte -->
    <div v-show="!collection_loading && Object.keys(item).length" class="cd-mobile-trailer">
      <CollectionCardTrailer :collection-detail-url="CollectionDetailUrl"
                             :collection-id="collectionId"
                             :is-following="isFollowing"
                             :is-owner="userInfo.id === item.user_id"
                             :item="item"
                             @delete="handleCollectionToDelete"
                             @start="handleStart"
                             @add-content="showAddContentModal"
                             @toggle-share="showShareArea = !showShareArea"
                             @follow-unfollow="collectionFollowUnfollow"
                             @cover-updated="onCoverUpdated"
      />
    </div>

    <div v-show="!collection_loading && Object.keys(item).length" class="cd-container">
      <div class="cd-layout">
        <div class="cd-sidebar">
          <div class="cd-sidebar-card">
            <CollectionCardTrailer :collection-detail-url="CollectionDetailUrl"
                                   :collection-id="collectionId"
                                   :is-following="isFollowing"
                                   :is-owner="userInfo.id === item.user_id"
                                   :item="item"
                                   @delete="handleCollectionToDelete"
                                   @start="handleStart"
                                   @add-content="showAddContentModal"
                                   @toggle-share="showShareArea = !showShareArea"
                                   @follow-unfollow="collectionFollowUnfollow"
                                   @cover-updated="onCoverUpdated"
            />
          </div>
        </div>

        <div class="cd-main">
          <!-- Header / Description -->
          <div class="cd-header">
            <div class="cd-hero">
              <div class="cd-hero-content">
                <h1 class="cd-title">{{ item.name }}</h1>
                <div class="cd-meta-row">
                  <div class="cd-meta-item">
                    <i class="icon-feather-flag"></i>
                    <span>{{ $t("collectionDetail.start_date") }}: {{ fixDate(item.created_at) }}</span>
                  </div>
                  <div v-if="typeof item.user !== 'undefined'" class="cd-meta-item">
                    <i class="icon-feather-user"></i>
                    <span>
                      {{ $t("collectionDetail.who_created") }}:
                      <router-link :to="{ name: 'user.show' }">
                        {{ item.user.name + ' ' + item.user.surname }}
                      </router-link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Alerts -->
          <div v-if="successMessage != null" class="cd-alert cd-alert--success">
            <i class="icon-feather-check-circle"></i>
            <span>{{ successMessage }}</span>
            <a class="cd-alert-close" @click="successMessage = null"><i class="uil-times"></i></a>
          </div>
          <div v-if="errorMessage != null" class="cd-alert cd-alert--danger">
            <i class="icon-feather-alert-circle"></i>
            <span>{{ errorMessage }}</span>
            <a class="cd-alert-close" @click="errorMessage = null"><i class="uil-times"></i></a>
          </div>

          <CollectionShareArea v-if="collectionId"
                               :collection-id="collectionId"
                               :shared-ids="sharedIds"
                               :users="shareUsers"
                               :visible="showShareArea"
                               @close="showShareArea = false"
                               @error="errorMessage = restError"
                               @saved="successMessage = $t('collectionDetail.collection_shared_successfully')"
                               @open-modal="shareHistoryMode = false; showShareUserModal = true"
                               @open-history="shareHistoryMode = true; showShareUserModal = true"
          />

          <!-- Tabs + Content -->
          <div class="cd-tab-wrapper">
            <div class="cd-tab-nav">
              <ul
                  uk-switcher="connect: #course-intro-tab ;animation: uk-animation-slide-right-medium, uk-animation-slide-left-medium">
                <li>
                  <a href="javascript:void(0)">
                    <i class="uil-list-ul"></i>
                    <span>{{ $t("collectionDetail.contents") }}</span>
                  </a>
                </li>
                <li v-if="item.is_public">
                  <a href="javascript:void(0)">
                    <i class="uil-comment-info-alt"></i>
                    <span>{{ $t("education.Sharing_Experience") }}</span>
                  </a>
                </li>
              </ul>
            </div>

            <ul id="course-intro-tab" class="uk-switcher cd-tab-content">
              <li>
                <!-- Mobil: koleksiyon bilgileri -->
                <div class="cd-mobile-info">
                  <h1 class="cd-mobile-info__title">{{ item.name }}</h1>
                  <ul class="cd-mobile-info__meta">
                    <li>
                      <i class="icon-feather-flag"></i>
                      {{ $t("collectionDetail.start_date") }}: {{ fixDate(item.created_at) }}
                    </li>
                    <li v-if="typeof item.user !== 'undefined'">
                      <i class="icon-feather-user"></i>
                      {{ $t("collectionDetail.who_created") }}:
                      <router-link :to="{ name: 'user.show' }">
                        {{ item.user.name + ' ' + item.user.surname }}
                      </router-link>
                    </li>
                  </ul>
                </div>

                <div class="cd-section-header">
                  <h4>{{ $t("collectionDetail.contents") }}</h4>
                </div>

                <CollectionContentList :contents="item.contents"
                                       :is-owner="userInfo.id === item.user_id"
                                       :order-saving="contentOrderSaving"
                                       @download="downloadURI"
                                       @edit="showEditContentModal"
                                       @remove="removeContent"
                                       @save-order="saveContentOrder"
                />
              </li>

              <li v-if="item.is_public">
                <div class="cd-section-header">
                  <h4>
                    {{ $t('education.Sharing_Experience') }}
                    <span style="font-size: 14px; font-weight: 400; color: #64748b; margin-left: 4px;">
                      ({{ (item.comments || []).length }} {{ $t("education.Sharing") }})
                    </span>
                  </h4>
                </div>

                <CollectionFeedbacks :comment-text="comment_text"
                                     :comments="item.comments || []"
                                     :item="item"
                                     :user-photo="userInfo.photo"
                                     @submit="makeComment"
                                     @update:commentText="comment_text = $event"
                />
              </li>
            </ul>
          </div>

          <CollectionEditForm v-if="collectionId"
                              :collection-id="collectionId"
                              :item="item"
                              :visible="userInfo.id === item.user_id"
                              @error="errorMessage = restError"
                              @saved="onDetailSaved"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/az';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
import ApiService from "@/core/services/api.service";
import CollectionDetailSkeleton from "@/view/User/CollectionDetails/components/CollectionDetailSkeleton.vue";
import CollectionContentModal from "@/view/User/CollectionDetails/components/CollectionContentModal.vue";
import CollectionShareModal from "@/view/User/CollectionDetails/components/CollectionShareModal.vue";
import CollectionShareArea from "@/view/User/CollectionDetails/components/CollectionShareArea.vue";
import CollectionContentList from "@/view/User/CollectionDetails/components/CollectionContentList.vue";
import CollectionEditForm from "@/view/User/CollectionDetails/components/CollectionEditForm.vue";
import CollectionCardTrailer from "@/view/User/Collections/components/CollectionCardTrailer.vue";
import CollectionFeedbacks from "@/view/User/CollectionDetails/components/CollectionFeedbacks.vue";
import AppModal from "@/view/components/ui/AppModal.vue";
import PageHeader from "@/view/components/common/PageHeader.vue";
import { confirmDialogDelete } from "@/utils/confirmDialog";
import { showError, showSuccess } from "@/utils/alertUtils.js";

import {
  DELETE_ITEM_BY_ID,
  ERROR as REST_ERROR,
  GET_ITEM_DETAIL_BY_ID,
  LOADING as REST_LOADING,
  UPDATE_ITEM_BY_ID
} from "@/core/services/store/REST.module";

export default {
  name: "CollectionDetails",
  components: {
    CollectionDetailSkeleton,
    CollectionContentModal,
    CollectionShareModal,
    CollectionShareArea,
    CollectionContentList,
    CollectionEditForm,
    CollectionCardTrailer,
    CollectionFeedbacks,
    AppModal,
    PageHeader
  },
  data() {
    return {
      CollectionDetailUrl: "api/collection/",
      CollectionRemoveContentUrl: "api/collection/content/",
      CollectionCommentUrl: "api/collection/comment/",
      item: {},
      errorMessage: null,
      successMessage: null,
      showShareArea: false,
      showAddContentModalVisible: false,
      showEditContentModalVisible: false,
      selectedExternalContent: null,
      contentOrderSaving: false,
      showShareUserModal: false,
      shareHistoryMode: false,
      shareUsers: [],
      sharedIds: [],
      isFollowing: false,
      collectionId: null,
      comment_text: "",
    };
  },
  computed: {
    activeLanguageCode() {
      return String((this.$i18n && this.$i18n.locale) || this.secureLocalStorage("language") || "tr").toLowerCase();
    },
    userInfo: {
      get: function () {
        return this.authUser
      },
      set: function (newValue) {
      },
    },
    collection_loading: {
      get() {
        return this.$store.getters[REST_LOADING];
      },
      set(value) {
      },
    },
    restError: {
      get() {
        return this.$store.getters[REST_ERROR];
      },
      set(value) {
      },
    },
  },
  methods: {
    loadCollectionFromRoute(collectionId) {
      if (!collectionId) {
        this.$router.go(-1);
        return;
      }

      this.collectionId = collectionId;
      this.resetCollectionState();
      this.getResultItems();
      this.getUserList();
    },
    resetCollectionState() {
      this.item = {};
      this.errorMessage = null;
      this.successMessage = null;
      this.showShareArea = false;
      this.showAddContentModalVisible = false;
      this.showEditContentModalVisible = false;
      this.selectedExternalContent = null;
      this.contentOrderSaving = false;
      this.showShareUserModal = false;
      this.shareHistoryMode = false;
    },
    handleStart() {
      if (this.item.contents && this.item.contents.length > 0) {
        const firstContent = this.item.contents[0];
        if (this.checkModelControl(firstContent)) {
          this.goPage(firstContent.pivot.contentable_id, firstContent.pivot.contentable_type);
        } else {
          this.downloadURI(firstContent.url || firstContent.file_link);
        }
      }
    },
    downloadURI(uri) {
      window.open(uri);
      this.successMessage = this.$t("collectionDetail.content_opened");
      return false;
    },
    showAddContentModal() {
      this.showAddContentModalVisible = true;
    },
    showEditContentModal(content) {
      this.selectedExternalContent = content;
      this.showEditContentModalVisible = true;
    },
    addContentModalSubmit() {
      setTimeout(() => {
        this.showAddContentModalVisible = false;
      }, 1000);
      this.getResultItems();
    },
    editContentModalSubmit() {
      setTimeout(() => {
        this.showEditContentModalVisible = false;
        this.selectedExternalContent = null;
      }, 1000);
      this.getResultItems();
    },
    onCoverUpdated(newLink) {
      this.$set(this.item, 'cover_image_link', newLink);
    },
    onDetailSaved(data) {
      const contents = this.item.contents;
      const currentComments = this.item.comments; // Mevcut yorumları koru
      this.item = { ...data, contents };
      this.item.is_public = this.normalizePublicValue(data.is_public);

      // Eğer API'dan comments gelmemişse, mevcut yorumları koru
      if (!data.comments && currentComments) {
        this.$set(this.item, 'comments', currentComments);
      }

      // Başarı mesajı göster
      showSuccess(this.$t('general.saved_successfully'));

      // Yukarı scroll yap
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    normalizePublicValue(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    saveContentOrder(contents) {
      const orderedPivotIds = (contents || [])
          .map((content) => content && content.pivot && content.pivot.id)
          .filter((id) => id !== null && typeof id !== "undefined");

      let form = new FormData();
      form.append("_method", "PUT");
      orderedPivotIds.forEach((id) => form.append("order[]", id));

      this.contentOrderSaving = true;
      ApiService.post(this.CollectionDetailUrl + this.collectionId, form)
          .then((response) => {
            this.contentOrderSaving = false;
            this.successMessage = this.$t('general.saved_successfully');
            if (response && response.data) {
              const currentContents = contents || this.item.contents;
              this.item = { ...response.data, contents: currentContents };
              this.item.is_public = this.normalizePublicValue(response.data.is_public);
            }
          })
          .catch(() => {
            this.contentOrderSaving = false;
            this.errorMessage = this.restError;
          });
    },
    goPage(id, name) {
      this.$router.push({ name: this.getModelRouteName(name), params: { id: id } });
    },
    collectionFollowUnfollow(follow) {
      let self = this;
      let form = new FormData();

      form.append("follow", follow);
      form.append("_method", 'PUT');

      this.$store.dispatch(UPDATE_ITEM_BY_ID, {
        url: this.CollectionDetailUrl + "follow-unfollow/" + this.collectionId,
        contents: form,
        acceptPromise: true
      })
          .then((result) => {
            if (result.status) {
              if (typeof result.data.follow !== "undefined") {
                self.isFollowing = result.data.follow;
              }
            } else {
              //this.errorMessage = this.restError;
            }
          });
    },

    fixDate(value) {
      return moment(value).locale(this.activeLanguageCode).format('DD MMMM YYYY');
    },
    async handleCollectionToDelete() {
      const confirmed = await confirmDialogDelete({ context: this });
      if (!confirmed) return;
      this.$store
          .dispatch(DELETE_ITEM_BY_ID, {
            url: this.CollectionDetailUrl + this.collectionId,
          })
          .then((result) => {
            if (!this.restError) {
              this.$router.push({ name: 'user.my-collection' });
            } else this.errorMessage = this.restError;
          });
    },
    getModelRouteName(model = '') {
      let model_name = model.split('\\').pop()
      switch (model_name) {
        case 'Assignment':
          return 'user.assignment-detail'
        case 'Training':
          return 'user.education-detail'
        default:
          return ''
      }
    },
    checkModelAble(model = '') {
      return model.split('\\').pop()
    },
    checkModelControl(content) {
      return content.pivot && this.checkModelAble(content.pivot.contentable_type) != 'CollectionExternalContent' && content.pivot.contentable_type != null;
    },
    async removeContent(content_id) {
      const confirmed = await confirmDialogDelete({ context: this });
      if (!confirmed) return;
      let form = new FormData();
      form.append("collection_content_id", content_id);
      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, {
            url: this.CollectionRemoveContentUrl + this.collectionId,
            contents: form,
            acceptPromise: true
          })
          .then((result) => {
            if (!this.restError) {
              this.getResultItems()
            } else this.errorMessage = this.restError;
          });
    },
    getResultItems() {
      this.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: this.CollectionDetailUrl + this.collectionId,
            acceptPromise: false,
          })
          .then((result) => {
            if (typeof result !== "undefined" && result.status) {
              const currentComments = this.item.comments; // Mevcut yorumları koru
              this.item = result.data;
              this.item.is_public = this.normalizePublicValue(result.data.is_public);

              // Eğer API'dan comments gelmemişse, mevcut yorumları koru
              if (!result.data.comments && currentComments) {
                this.$set(this.item, 'comments', currentComments);
              }

              if (typeof this.item.follows !== 'undefined') {
                this.isFollowing = (this.item.follows.length > 0) ? true : false;
              }
            }
          });
    },
    getUserList() {
      ApiService.get("api/collection-users/" + this.collectionId)
          .then((response) => {
            this.shareUsers = response.data.users;
            this.sharedIds = response.data.sharedIds;
            if (response.data.comments) {
              this.$set(this.item, 'comments', response.data.comments);
            }
          });
    },
    makeComment() {
      if (this.comment_text.length < 2) {
        this.errorMessage = this.$t("validation.required_field").replace(
          ":NAME",
          this.$t("assignment.comment")
        );
        return false;
      }
      let formData = new FormData();
      formData.append("comment", this.comment_text);
      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, {
            url: this.CollectionCommentUrl + this.collectionId,
            contents: formData,
          })
          .then((result) => {
            if (!this.restError) {
              this.comment_text = "";
              if (Object.keys(result.data).length) {
                if (!this.item.comments) {
                  this.$set(this.item, 'comments', []);
                }
                this.item.comments.unshift(result.data);
              }
              this.successMessage = this.$t("general.successfully_created");
            } else {
              this.errorMessage = this.restError;
            }
          });
    },
  },
  mounted() {
    this.loadCollectionFromRoute(this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== from.params.id) {
      this.loadCollectionFromRoute(to.params.id);
    }
    next();
  },
};
</script>

<style src="./collection-details.css"></style>
